<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">{{form.modal.title}}</h4>
        </div>
        <div class="modal-body">
          <form @submit.prevent="form.onSubmit({ updateStore: true, updateList:true })" @keydown="form.errors.clear($event.target.id)">
            <input type="hidden" name="id" v-model="form.data.id">

            <div class="checkbox" :class="{'has-error': form.errors.has('isActive') }">
              <label>
                <input type="checkbox" id="isActive" v-model="form.data.isActive"> Active
               <span class="optional">(optional)</span></label>
              <span class="help-block" v-if="form.errors.has('isActive')" v-text="form.errors.get('isActive')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('contractId') }">
              <label class="control-label">Contract</label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.contractId">
                  <option></option>
                  <option v-for="item in contracts" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('contractId')" v-text="form.errors.get('contractId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('requestTypeId') }">
              <label class="control-label">Request Type</label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.requestTypeId">
                  <option></option>
                  <option v-for="item in requestTypes" v-bind:value="item.id">{{item.attributes.kind}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('requestTypeId')" v-text="form.errors.get('requestTypeId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('firstName') }">
              <label class="control-label">Contact First Name</label>
              <input type="text" class="form-control" id="firstName" v-model="form.data.firstName">
              <span class="help-block" v-if="form.errors.has('firstName')" v-text="form.errors.get('firstName')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('lastName') }">
              <label class="control-label">Contact Last Name </label>
              <input type="text" class="form-control" id="lastName" v-model="form.data.lastName">
              <span class="help-block" v-if="form.errors.has('lastName')" v-text="form.errors.get('lastName')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('email') }">
              <label class="control-label">Email</label>
              <input type="text" class="form-control" id="email" v-model="form.data.email">
              <span class="help-block" v-if="form.errors.has('email')" v-text="form.errors.get('email')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('email2') }">
              <label class="control-label">Alt Email <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="email2" v-model="form.data.email2">
              <span class="help-block" v-if="form.errors.has('email2')" v-text="form.errors.get('email2')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('phone') }">
              <label class="control-label">Phone</label>
              <input type="text" class="form-control" id="phone" v-model="form.data.phone">
              <span class="help-block" v-if="form.errors.has('phone')" v-text="form.errors.get('phone')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('alt_phone') }">
              <label class="control-label">Alt Phone <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="alt_phone" v-model="form.data.alt_phone">
              <span class="help-block" v-if="form.errors.has('alt_phone')" v-text="form.errors.get('alt_phone')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('address') }">
              <label class="control-label">Address</label>
              <input type="text" class="form-control" id="address" v-model="form.data.address">
              <span class="help-block" v-if="form.errors.has('address')" v-text="form.errors.get('address')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('city') }">
              <label class="control-label">City</label>
              <input type="text" class="form-control" id="city" v-model="form.data.city">
              <span class="help-block" v-if="form.errors.has('city')" v-text="form.errors.get('city')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('stateId') }">
              <label class="control-label">State</label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.stateId">
                  <option></option>
                  <option v-for="item in states" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('stateId')" v-text="form.errors.get('stateId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('zip') }">
              <label class="control-label">Zip</label>
              <input type="text" class="form-control" id="zip" v-model="form.data.zip">
              <span class="help-block" v-if="form.errors.has('zip')" v-text="form.errors.get('zip')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('addressMailing') }">
              <label class="control-label">Mailing Address <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="addressMailing" v-model="form.data.addressMailing">
              <span class="help-block" v-if="form.errors.has('addressMailing')" v-text="form.errors.get('addressMailing')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('reason') }">
              <label class="control-label">Reason <span class="optional">(optional)</span></label>
              <textarea class="form-control" id="reason" v-model="form.data.reason"></textarea>
              <span class="help-block" v-if="form.errors.has('reason')" v-text="form.errors.get('reason')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('countyId') }">
              <label class="control-label">County <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.countyId">
                  <option></option>
                  <option v-for="item in counties" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('countyId')" v-text="form.errors.get('countyId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('zoneId') }">
              <label class="control-label">Zone <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.zoneId">
                  <option></option>
                  <option v-for="item in zones" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('zoneId')" v-text="form.errors.get('zoneId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('routeId') }">
              <label class="control-label">Spray Route <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.routeId">
                  <option></option>
                  <option v-for="item in routes" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('routeId')" v-text="form.errors.get('routeId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('municipalityId') }">
              <label class="control-label">Municipality <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.municipalityId">
                  <option></option>
                  <option v-for="item in municipalities" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('municipalityId')" v-text="form.errors.get('municipalityId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('subdivisionId') }">
              <label class="control-label">Subdivision <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.subdivisionId">
                  <option></option>
                  <option v-for="item in subdivisions" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('subdivisionId')" v-text="form.errors.get('subdivisionId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('yearRenewed') }">
              <label class="control-label">Year Renewed <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="yearRenewed" v-model="form.data.yearRenewed">
              <span class="help-block" v-if="form.errors.has('yearRenewed')" v-text="form.errors.get('yearRenewed')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('latitude') }">
              <label class="control-label">GPS-Latitude <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="latitude" v-model="form.data.latitude">
              <span class="help-block" v-if="form.errors.has('latitude')" v-text="form.errors.get('latitude')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('longitude') }">
              <label class="control-label">GPS-Longitude <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="longitude" v-model="form.data.longitude">
              <span class="help-block" v-if="form.errors.has('longitude')" v-text="form.errors.get('longitude')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('near_zone_1') }">
              <label class="control-label">Near Zone 1 <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="near_zone_1" v-model="form.data.near_zone_1">
              <span class="help-block" v-if="form.errors.has('near_zone_1')" v-text="form.errors.get('near_zone_1')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('near_zone_2') }">
              <label class="control-label">Near Zone 2 <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="near_zone_2" v-model="form.data.near_zone_2">
              <span class="help-block" v-if="form.errors.has('near_zone_2')" v-text="form.errors.get('near_zone_2')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('near_zone_3') }">
              <label class="control-label">Near Zone 3 <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="near_zone_3" v-model="form.data.near_zone_3">
              <span class="help-block" v-if="form.errors.has('near_zone_3')" v-text="form.errors.get('near_zone_3')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('fog') }">
              <label class="control-label">Fog <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="fog" v-model="form.data.fog">
              <span class="help-block" v-if="form.errors.has('fog')" v-text="form.errors.get('fog')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('deactivatedDate') }">
              <label class="control-label">Deactivated Date <span class="optional">(optional)</span></label>
              <date-picker v-model="form.data.deactivatedDate"></date-picker>
              <span class="help-block" v-if="form.errors.has('deactivatedDate')" v-text="form.errors.get('deactivatedDate')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('deactivatedComment') }">
              <label class="control-label">Deactivated Comment <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="deactivatedComment" v-model="form.data.deactivatedComment">
              <span class="help-block" v-if="form.errors.has('deactivatedComment')" v-text="form.errors.get('deactivatedComment')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('notes') }">
            <label class="control-label">Comments <span class="optional">(optional)</span></label>
              <textarea class="form-control" id="notes" v-model="form.data.notes"></textarea>
            <span class="help-block" v-if="form.errors.has('notes')" v-text="form.errors.get('notes')"></span>
          </div>

            <loading-button :loading="form.loading" class="btn btn-primary" :disabled="form.errors.any()">Save</loading-button>
            <button type="button" class="btn btn-default" data-dismiss="modal">cancel</button>
          </form>
        </div>
        <div class="modal-footer">
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal -->
</template>

<script>
  import LoadingButton from '@/components/loading-button';
  import DatePicker from '@/components/date-picker';

  export default {
    name: 'no-spray-form',

    props: ['form'],

    components: {
      LoadingButton,
      DatePicker,
    },

    computed: {
      contracts() {
        return this.$store.getters.contracts;
      },
      counties() {
        return this.$store.getters.counties;
      },
      routes() {
        return this.$store.getters.routes;
      },
      municipalities() {
        return this.$store.getters.municipalities;
      },
      subdivisions() {
        return this.$store.getters.subdivisions;
      },
      requestTypes() {
        return this.$store.getters.requestTypes;
      },
      states() {
        return this.$store.getters.states;
      },
      zones() {
        return this.$store.getters.zones;
      },
    },

  }

</script>